import { WarningFilled } from "@ant-design/icons";

const UiWarningRating = ({ count = 0 }) => {
  const totalWarnings = 3; 
  return (
    <div style={{ display: "flex", gap: 4 }}>
      {Array.from({ length: totalWarnings }).map((_, index) => (
        <WarningFilled
          key={index}
          style={{
            color: index < count ? "#faad14" : "#d9d9d9",
            fontSize: 20,
          }}
        />
      ))}
    </div>
  );
};

export default UiWarningRating;
